<div class="bolt-container-fluid">
  <div class="bolt-row">
    <div class="bolt-col-xs-12 bolt-col-md-5 quote-pdf-col">
      <bolt-button
        class="quote-pdf-button"
        [disabled]="!content.quotePdfAvailable"
        id="quoteLetterPdf"
        (click)="showPdf.next()"
        iconright="download"
        >
        Quote PDF
      </bolt-button>
    </div>
    <div class="bolt-col-xs-12 bolt-col-md-7 card">
      <div class="bolt-container-fluid">
        <div class="bolt-row">
          <div class="bolt-col-xs-12 bolt-col-md-7 package-titles">
            <div class="package-title">Total package premium of all terms</div>
            <div class="package-subtitle">Discounts included in prices</div>
          </div>
          <div class="bolt-col-xs-12 bolt-col-md-5 package-price">
            @if (content.quoteInProgressCount) {
              <nwx-passive-spinner
                class="flat"
                label="Loading"
              ></nwx-passive-spinner>
            } @else {
              @if (showPackagePremium()) {
                <div class="premium">
                  {{
                  isNumber(content.totalPremium)
                  ? (content.totalPremium | currency)
                  : content.totalPremium
                  }}
                </div>
              } @else {
                <div class="premium">$--.--</div>
              }
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
